import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-mic-off',
  templateUrl: './icon-mic-off.component.html',
  styleUrls: ['./icon-mic-off.component.scss']
})
export class IconMicOffComponent implements OnInit {
  @Input() color: string = '#262628';
  @Input() size: number = 18;

  constructor() { }

  ngOnInit() {
  }

}
